export const TFA_CONFIG = 'TFA_CONFIG'
export const TFA_CONFIGS = 'TFA_CONFIGS'
export const CURRENT_USER = 'CURRENT_USER'
export const TOKEN = 'TOKEN'
export const USERS = 'USERS'
export const EMAILS = 'EMAILS'
export const PASSWORDS = 'PASSWORDS'
export const ROLES = 'ROLES'
export const INVITES = 'INVITES'
export const RECOVERY_INVITES = 'RECOVERY_INVITES'
export const RECOVERY_REQUEST = 'RECOVERY_REQUEST'
export const RECOVERY_CONTACTS = 'RECOVERY_CONTACTS'
export const RELEASED_KEY_SHARES = 'RELEASED_KEY_SHARES'
export const PENDING_WRAPS = 'PENDING_WRAPS'
export const CLIENTS = 'CLIENTS'
export const CONSENTS = 'CONSENTS'
export const DELETE_USER = 'DELETE_USER'
export const APPLICATIONS = 'APPLICATIONS'
export const VERSIONS = 'VERSIONS'
export const OAUTH = 'OAUTH'
export const FAKTORY = 'FAKTORY'
export const SESSION = 'SESSION'
export const SETTINGS = 'SETTINGS'
export const USER_KEY = 'USER_KEY'
